import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "card-body p-0"
}
const _hoisted_3 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_4 = { class: "w-50" }
const _hoisted_5 = { class: "w-50 d-flex justify-content-end" }
const _hoisted_6 = { class: "w-50" }
const _hoisted_7 = { class: "d-flex flex-column w-100 mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Subject")
], -1)
const _hoisted_9 = { class: "d-flex flex-column justify-content-start mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Email Body")
], -1)
const _hoisted_11 = { class: "w-100 d-flex flex-row justify-content-end mb-10" }
const _hoisted_12 = ["data-kt-indicator"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaceholderSelect = _resolveComponent("PlaceholderSelect")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.pageLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_PlaceholderSelect, {
                  options: _ctx.placeholderOptions,
                  onChange: _ctx.handlePlaceholderChange,
                  onClose: _ctx.handlePlaceholderClose
                }, null, 8, ["options", "onChange", "onClose"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              placeholder: "Please input",
              class: "input-with-select",
              modelValue: this.formData.subject,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.formData.subject) = $event)),
              ref: "subjectInput",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleElementFocus($event, 'subjectInput'))),
              onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleElementCursor($event))),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleElementCursor($event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Editor, {
              "output-format": "html",
              modelValue: this.formData.body,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.formData.body) = $event)),
              "api-key": _ctx.api_key,
              init: _ctx.config,
              ref: "editorInput",
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleElementFocus($event, 'editorInput')))
            }, null, 8, ["modelValue", "api-key", "init"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleSubmitForm && _ctx.handleSubmitForm(...args))),
              class: "btn btn-new-design-primary fw-bolder ms-4",
              "data-kt-indicator": _ctx.formSubmitted ? 'on' : null
            }, _hoisted_15, 8, _hoisted_12)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 1,
          rows: 5
        }))
  ]))
}